import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { WorkstationCodec, Workstation, Data } from "../store/workstation/types";
import { withDecoded, flattenData } from "./";

function mapToModel(data: object): Workstation {
  return withDecoded(WorkstationCodec, data, (decoded) => ({
    ...decoded,
  }));
}

export async function fetch(
  id?: string | null,
  params?: {}
): Promise<Workstation> {
  return fetchApi({
    nestedResourcePath: ["workstation"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(group: Data): Promise<Workstation> {
  return insertApi({
    nestedResourcePath: ["workstation"],
    id: group.id,
    data: { data: group },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<any> {
  return dropApi({
    nestedResourcePath: ["workstation"],
    id: id,
  }).then((response) => response.data);
}
